import { tutorial as baseTutorial } from './baseApi/tutorial'

export type * from './baseApi/tutorial'

export const tutorialApi = baseTutorial.enhanceEndpoints({
  addTagTypes: ['Tutorial'],
  endpoints: {
    getTutorial: {
      providesTags: ['Tutorial'],
    },
  },
})

export const {
  useGetTutorialQuery,
  useGetTutorialByTutorialIdQuery,
  usePostTutorialByTutorialIdMutation,
  useDeleteTutorialByTutorialIdMutation,
} = tutorialApi
